// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Capacitor } from "@capacitor/core";

export function isCapacitorPlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function isAndroidPlatform(): boolean {
  return Capacitor.getPlatform() === "android";
}

export function isIosPlatform(): boolean {
  return Capacitor.getPlatform() === "ios";
}
